import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/dcb38a566d4496e765f76dd519f23df6.png"
          alt="Casa moderna na Flórida construída pela Bravia Group"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Construímos lares.<br />Você constrói legado.
        </h1>
        <p className="text-xl text-white/90 font-light leading-relaxed mb-10 max-w-2xl">
          A Bravia Group é um hub de investidores com projetos de construção residencial, com processo claro, acompanhamento e entrega.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://wa.me/5511999999999"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-4 bg-gold-500 text-gray-900 rounded-full font-semibold text-base hover:bg-gold-400 transition-all shadow-lg whitespace-nowrap text-center cursor-pointer"
          >
            Quero falar com um especialista
          </a>
          <Link
            to="/projetos"
            className="px-8 py-4 border-2 border-white text-white rounded-full font-semibold text-base hover:bg-white/10 transition-all whitespace-nowrap text-center"
          >
            Ver projetos
          </Link>
        </div>
      </div>
    </section>
  );
}
